import * as React from 'react';

function IconPlayVideo(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5 10a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0zm1.667 0A9.167 9.167 0 11.833 10a9.167 9.167 0 0118.334 0zM8.333 13.608l5-3.608-5-3.608v7.216z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoIconPlayVideo = React.memo(IconPlayVideo);
export default MemoIconPlayVideo;
